// extracted by mini-css-extract-plugin
export default {"page":"O2-z","cartModal":"P2-z","checkout":"Q2-z","placeholder":"R2-z","account":"S2-z"};